module.exports = __webpack_public_path__ + "fonts/GothamNarrow-Thin.4921472b.otf";